module.exports = "/images/contract-cht-page-8.jpg?641dbc3a50bb32e922dc21456ed28354";